"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var dashboardEndpoint = function dashboardEndpoint(client) {
  return {
    get: function () {
      var _get = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _data$menu;
        var _yield$client$restCli, data;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return client.restClient.get('/plurall-dashboard');
            case 2:
              _yield$client$restCli = _context.sent;
              data = _yield$client$restCli.data;
              return _context.abrupt("return", (data === null || data === void 0 ? void 0 : (_data$menu = data.menu) === null || _data$menu === void 0 ? void 0 : _data$menu.items) || []);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function get() {
        return _get.apply(this, arguments);
      }
      return get;
    }()
  };
};
var _default = dashboardEndpoint;
exports.default = _default;